import { render, staticRenderFns } from "./editPwd.vue?vue&type=template&id=46c046d0&"
import script from "./editPwd.vue?vue&type=script&lang=js&"
export * from "./editPwd.vue?vue&type=script&lang=js&"
import style0 from "./editPwd.vue?vue&type=style&index=0&id=46c046d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports